import { useState, useCallback } from 'react';

/**
 * Custom hook for managing data refresh functionality
 * @param {Function} onRefresh - The function to call when refreshing data
 * @param {Array} resetFunctions - Array of functions to reset component states
 * @returns {Object} Object containing refresh function and refresh state
 */
export const useRefreshData = (onRefresh, resetFunctions = []) => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = useCallback(async () => {
    if (isRefreshing) return; 
    
    try {
      resetFunctions.forEach(resetFn => {
        if (typeof resetFn === 'function') {
          resetFn();
        }
      });
      setIsRefreshing(true);
      await onRefresh();
    } catch (error) {
      console.error('Error refreshing data:', error);
    } finally {
      setIsRefreshing(false);
    }
  }, [onRefresh, isRefreshing, resetFunctions]);

  return {
    handleRefresh,
    isRefreshing,
  };
};

export default useRefreshData; 